__turbopack_context__.v({
  "container": "SerwizzSection-module-scss-module__K9dPeW__container",
  "content": "SerwizzSection-module-scss-module__K9dPeW__content",
  "description": "SerwizzSection-module-scss-module__K9dPeW__description",
  "imageWrapper": "SerwizzSection-module-scss-module__K9dPeW__imageWrapper",
  "link": "SerwizzSection-module-scss-module__K9dPeW__link",
});
